/* Allied Motor Parts - PDP shipping estimator (CC rebuild, Sep 2026).
   Prices a throwaway Storefront API cart (this variant + the shopper's ZIP) and shows the
   delivery options Shopify would offer at checkout, carrier-calculated rates included.
   The Storefront token is a public, client-side token limited to cart + product-listing scopes. */
(function () {
  'use strict';
  var root = document.querySelector('[data-cc-ship]');
  if (!root) return;

  var SHOP = root.getAttribute('data-shop');
  var TOKEN = root.getAttribute('data-token');
  var API = 'https://' + SHOP + '/api/2025-07/graphql.json';
  var PHONE = root.getAttribute('data-phone') || '';
  var KEY_ZIP = 'cc_ship_zip';

  /* USPS 3-digit ZIP prefix -> state (needed for rating) */
  var ZIP3 = [[5,5,'NY'],[6,9,'PR'],[10,27,'MA'],[28,29,'RI'],[30,38,'NH'],[39,49,'ME'],[50,59,'VT'],[60,69,'CT'],[70,89,'NJ'],[100,149,'NY'],[150,196,'PA'],[197,199,'DE'],[200,200,'DC'],[201,201,'VA'],[202,205,'DC'],[206,219,'MD'],[220,246,'VA'],[247,268,'WV'],[270,289,'NC'],[290,299,'SC'],[300,319,'GA'],[320,349,'FL'],[350,369,'AL'],[370,385,'TN'],[386,397,'MS'],[398,399,'GA'],[400,427,'KY'],[430,459,'OH'],[460,479,'IN'],[480,499,'MI'],[500,528,'IA'],[530,549,'WI'],[550,567,'MN'],[570,577,'SD'],[580,588,'ND'],[590,599,'MT'],[600,629,'IL'],[630,658,'MO'],[660,679,'KS'],[680,693,'NE'],[700,714,'LA'],[716,729,'AR'],[730,749,'OK'],[750,799,'TX'],[800,816,'CO'],[820,831,'WY'],[832,838,'ID'],[840,847,'UT'],[850,865,'AZ'],[870,884,'NM'],[885,885,'TX'],[889,898,'NV'],[900,961,'CA'],[967,968,'HI'],[970,979,'OR'],[980,994,'WA'],[995,999,'AK']];
  function stateFor(zip) {
    var p = parseInt(zip.slice(0, 3), 10);
    for (var i = 0; i < ZIP3.length; i++) { if (p >= ZIP3[i][0] && p <= ZIP3[i][1]) return ZIP3[i][2]; }
    return null;
  }

  var input = root.querySelector('[data-cc-ship-zip]');
  var button = root.querySelector('[data-cc-ship-go]');
  var result = root.querySelector('[data-cc-ship-result]');
  var head = root.querySelector('[data-cc-ship-form]');

  function variantId() {
    var el = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    return (el && el.value) || root.getAttribute('data-variant');
  }
  function money(a) {
    var n = parseFloat(a);
    return isNaN(n) ? a : '$' + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function esc(s) { return String(s || '').replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function gql(query, variables, multipart) {
    return fetch(API, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': multipart ? 'multipart/mixed; boundary=graphql, application/json' : 'application/json',
        'X-Shopify-Storefront-Access-Token': TOKEN
      },
      body: JSON.stringify({ query: query, variables: variables })
    }).then(function (r) { return multipart ? r.text() : r.json(); });
  }

  /* pull every deliveryOptions array out of a (possibly multipart / deferred) response */
  function extractOptions(text) {
    var out = [], re = /"deliveryOptions":(\[[^\]]*\])/g, m;
    while ((m = re.exec(text))) {
      try { out = out.concat(JSON.parse(m[1])); } catch (e) { /* ignore partial chunk */ }
    }
    return out;
  }

  function fetchRates(zip, state, vid) {
    var create = 'mutation($input:CartInput!){cartCreate(input:$input){cart{id} userErrors{message}}}';
    var cartInput = {
      lines: [{ merchandiseId: 'gid://shopify/ProductVariant/' + vid, quantity: 1 }],
      buyerIdentity: { countryCode: 'US' },
      delivery: { addresses: [{ selected: true, validationStrategy: 'COUNTRY_CODE_ONLY', address: { deliveryAddress: { countryCode: 'US', provinceCode: state, zip: zip } } }] }
    };
    return gql(create, { input: cartInput }).then(function (res) {
      var cart = res && res.data && res.data.cartCreate && res.data.cartCreate.cart;
      if (!cart) throw new Error('cart');
      var q = 'query($id:ID!){cart(id:$id){totalQuantity ... @defer{deliveryGroups(first:5,withCarrierRates:true){nodes{deliveryOptions{title description deliveryMethodType estimatedCost{amount currencyCode}}}}}}}';
      return gql(q, { id: cart.id }, true);
    }).then(function (text) {
      var opts = extractOptions(text).filter(function (o) { return o && o.estimatedCost; });
      opts.sort(function (a, b) { return parseFloat(a.estimatedCost.amount) - parseFloat(b.estimatedCost.amount); });
      return opts;
    });
  }

  function cacheKey(zip, vid) { return 'cc_ship_' + vid + '_' + zip; }

  function render(zip, opts) {
    var html = '<div class="cc-ship__to">Shipping to <strong>' + esc(zip) + '</strong> <button type="button" class="cc-ship__change" data-cc-ship-change>change</button></div>';
    if (!opts.length) {
      html += '<p class="cc-ship__none">We couldn’t get an instant quote for this ZIP. ' +
        (PHONE ? 'Call <a href="tel:' + esc(PHONE.replace(/[^\d+]/g, '')) + '">' + esc(PHONE) + '</a> for a shipping quote.' : 'Contact us for a shipping quote.') + '</p>';
    } else {
      html += '<ul class="cc-ship__list">' + opts.map(function (o, i) {
        return '<li class="cc-ship__opt' + (i === 0 ? ' cc-ship__opt--best' : '') + '">' +
          '<span class="cc-ship__name">' + esc(o.title) + '</span>' +
          '<span class="cc-ship__price">' + money(o.estimatedCost.amount) + '</span>' +
          (o.description ? '<span class="cc-ship__desc">' + esc(o.description) + '</span>' : '') +
          '</li>';
      }).join('') + '</ul>' +
      '<p class="cc-ship__note">Final rate confirmed at checkout.</p>';
    }
    result.innerHTML = html;
    result.hidden = false;
    head.hidden = true;
  }

  function showForm(msg) {
    result.hidden = true;
    head.hidden = false;
    var err = root.querySelector('[data-cc-ship-error]');
    err.textContent = msg || '';
    err.hidden = !msg;
    if (msg) input.focus();
  }

  var busy = false;
  function estimate(zip, fromSaved) {
    zip = (zip || '').trim();
    if (!/^\d{5}$/.test(zip)) { if (!fromSaved) showForm('Enter a 5-digit US ZIP code.'); return; }
    var state = stateFor(zip);
    if (!state || state === 'PR') { if (!fromSaved) showForm('We ship within the US. ' + (PHONE ? 'Call ' + PHONE + ' for other destinations.' : '')); return; }
    var vid = variantId();
    var cached = null;
    try { cached = JSON.parse(sessionStorage.getItem(cacheKey(zip, vid)) || 'null'); } catch (e) { cached = null; }
    if (cached) { render(zip, cached); return; }
    if (busy) return;
    busy = true;
    root.classList.add('is-loading');
    button.disabled = true;
    var oldLabel = button.textContent;
    button.textContent = 'Checking…';
    fetchRates(zip, state, vid).then(function (opts) {
      try { sessionStorage.setItem(cacheKey(zip, vid), JSON.stringify(opts)); } catch (e) {}
      try { localStorage.setItem(KEY_ZIP, zip); } catch (e) {}
      render(zip, opts);
    }).catch(function () {
      if (fromSaved) { showForm(''); return; }
      showForm('Sorry, the estimate is unavailable right now. Shipping is calculated at checkout.');
    }).then(function () {
      busy = false;
      root.classList.remove('is-loading');
      button.disabled = false;
      button.textContent = oldLabel;
    });
  }

  button.addEventListener('click', function () { estimate(input.value, false); });
  /* Enter in the ZIP box must estimate, not submit the surrounding product form */
  input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); e.stopPropagation(); estimate(input.value, false); } });
  input.addEventListener('input', function () { input.value = input.value.replace(/\D/g, '').slice(0, 5); });
  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-cc-ship-change]')) { showForm(''); input.focus(); }
  });

  /* variant change -> re-estimate for the saved ZIP */
  var vidInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
  if (vidInput && window.MutationObserver) {
    new MutationObserver(function () {
      var zip = result.hidden ? null : (localStorage.getItem(KEY_ZIP) || null);
      if (zip) estimate(zip, true);
    }).observe(vidInput, { attributes: true, attributeFilter: ['value'] });
  }

  /* returning shopper: reuse the remembered ZIP */
  var saved = null;
  try { saved = localStorage.getItem(KEY_ZIP); } catch (e) {}
  if (saved) { input.value = saved; estimate(saved, true); }
})();
